import { Adapter } from '@fmnts/core';
import { QuizField, QuizSelect, QuizTextbox } from '../model/quiz-field';

export class QuizFieldAdapter implements Adapter<QuizField> {
  adapt(item: Record<string, any>): QuizField {
    const baseField = {
      key: item['key'],
      label: item['label'],
      style: item['style'],
      widget: item['widget'],
      condition: undefined,
    };

    switch (item['widget']) {
      case 'note':
        return new QuizField(
          baseField,
          new QuizTextbox({
            text: item['text'],
            assets: item['assets'],
          }),
          'input',
        );
      case 'singleChoice':
      case 'multipleChoice':
      case 'result_multipleChoice':
      case 'result_singleChoice':
        return new QuizField(
          baseField,
          new QuizSelect({
            items: item['items'],
            scope: item['scope'],
            validators: item['validators'],
            defaultValue: item['value'],
          }),
          'input',
        );
    }

    return new QuizField(baseField, undefined, 'unknown');
  }
}

export class QuizFieldToApiAdapter {
  adaptModelToDto(item: QuizField): { [key: string]: any } {
    const baseProps = {
      key: item.key,
      label: item.label,
      widget: item.widget,
      style: item.style,
      condition: item.condition,
    };

    return { ...baseProps, ...item.widgetOptions };
  }
}
